import { useEffect } from 'react';

type useDocumentTitleProps = {
  title: string;
};

const useDocumentTitle = ({ title }: useDocumentTitleProps) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default useDocumentTitle;
